<template>
  <v-card>
    <v-card-title>کاردکس همه کالا ها</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-select :items="wareLevels" v-model="filters.level" label="سطح کالا" />
        </v-col>
        <v-col cols="12" md="4">
          <v-select :items="waresStatuses" v-model="filters.status" label="وضعیت کالا"></v-select>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-center justify-md-end">
          <v-btn v-if="isAdvari" @click="sortInventory" color="blue white--text">مرتب سازی کاردکس کالا</v-btn>
        </v-col>
        <v-col cols="12" class="all-wares-inventory">
          <m-datatable :api-url="url" :headers="headers" :filters.sync="filters" ref="datatable">
            <template #item.inventory="{ item }">
              <open-inventory-btn :wareId="item.id" />
            </template>
          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>

    <sort-inventory-error
      title="اتمام عملیات مرتب سازی کاردکس کالا به دلیل منفی شدن کالا های زیر امکان پذیر نیست"
      v-model="errorDialog"
      :errors="errors"
    />
  </v-card>
</template>

<script>
import _ from "lodash";
import wareApiMixin from "@/mixin/wareApi";
import MDatatable from "@/components/m-datatable";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";
import SortInventoryError from "@/components/SortInventoryError.vue";
export default {
  components: { MDatatable, OpenInventoryBtn, SortInventoryError },
  mixins: [wareApiMixin],
  data() {
    return {
      url: "reports/inventory/ware/all",
      headers: [
        {
          text: "کد",
          value: "code",
          sortable: false,
        },
        {
          text: "نام",
          value: "name",
          sortable: false,
        },
        {
          text: "واحد",
          value: "unit",
          sortable: false,
          filterable: false,
        },
        {
          text: "مقدار وارده",
          value: "input.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "فی وارده",
          value: "input.fee",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ وارده",
          value: "input.value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مقدار صادره",
          value: "output.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "فی صادره",
          value: "output.fee",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ صادره",
          value: "output.value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مقدار مانده",
          value: "remain.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "فی مانده",
          value: "remain.fee",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مبلغ مانده",
          value: "remain.value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "کاردکس",
          value: "inventory",
          sortable: false,
          filterable: false,
          hideInExport: true,
        },
      ],
      filters: {
        level: 3,
      },
      errors: [],
      errorDialog: false,
    };
  },
  methods: {
    sortInventory() {
      if (true || confirm(` آیا مرتب سازی کاردکس در سال مالی ${this.financialYear.name} انجام شود؟ `)) {
        this.request({
          url: this.endpoint(`wares/sortInventory`),
          method: "post",
          success: () => {
            this.successNotify();
            this.$refs.datatable.getDataFromApi();
          },
          error: (error) => {
            this.errors = error.response.data[0]["messages"];
            this.errorDialog = true;
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.all-wares-inventory #datatable > div.v-data-table__wrapper > table tr {
  td,
  th {
    &:nth-child(8),
    &:nth-child(11),
    &:nth-child(14) {
      border-right: 1px solid #e0e0e0 !important;
    }
  }
}
</style>
